import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Select } from 'antd';
import ResponseFilter from '../../ResponseFilter';
import { Tabs, Tab } from 'react-bootstrap';
import Pagination from "react-js-pagination";
import { Loader } from '../svg';
import { projectListByManager, projectActionByManager } from '../../config/services/employeeServices';
import _ from 'lodash';
const { Option } = Select;



const statusValue = type => {
  switch (type) {
    case 1:
      return 'Ongoing';
      break;
    case 2:
      return 'Completed';
      break;
    case 3:
      return 'Incomplete';
    case 4:
      return 'Maintenance';
    case 5:
      return 'On Hold'
  }
}
const colorType = type => {
  switch (type) {
    case 1: return 'text-primary';
      break;

    case 2: return 'text-success';
      break;
    case 4: return 'brown'
      break
    case 5: return 'orange'

    default: return 'text-danger';

  }
}
const handleDelayTime = (data) => {
  var delayedStatus;
  var date = new Date().setHours(0, 0, 0, 0);

  if (data >= new Date(date).setHours(0, 0, 0, 0)) {
    delayedStatus = `On Track`
  }

  else {
    var delay = (new Date(date).setHours(0, 0, 0, 0) - data) / 86400000
    delayedStatus = `${Math.floor(delay)} days`
  }

  return delayedStatus;
}

const ProjectTable = ({ projectList, loader, handleAction, pageNo, count, handleSort, sortType, sortField, date = new Date() }) => (
  <React.Fragment>
    {/* {projectList.length > 0 ? */}
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead className="white bg_blue">
          <tr>
            <th scope="col">S.No</th>
            <th scope="col">Project Name<i
              className={sortType === 1 && sortField === "projectName" ? "fa fa-sort-alpha-asc ml-2" : "fa fa-sort-alpha-desc ml-2"}
              onClick={() => handleSort('projectName')}></i></th>
            {/* <th scope="col"> Project Name</th> */}
            <th scope="col">Start Date<i
              className={sortType === 1 && sortField === "startDate" ? "fa fa-sort-numeric-asc ml-2" : "fa fa-sort-numeric-desc ml-2"}
              onClick={() => handleSort('startDate')}></i></th>
            <th scope="col">End Date</th>
            <th scope="col">Project Manager</th>
            <th scope="col"> Account Manager</th>
            <th scope="col">Client</th>
            <th>Delayed Status</th>
            <th scope="col" style={{ width: 130 }}>Status</th>

          </tr>
        </thead>
        <tbody>
          {!_.isEmpty(projectList) ?
            projectList.map((project, i) => (
              <tr>
                <td>{((i + 1) + ((pageNo - 1) * count))}</td>
                <td><span className="cm_col"><Link to={`/projects/manager-projects/project-detail/${project.projectId}`}>{project.projectName.charAt(0).toUpperCase() + project.projectName.slice(1)}</Link></span></td>
                <td>{moment.unix(project.startDate / 1000).format("DD/MM/YYYY")}</td>
                <td>{moment.unix(project.endDate / 1000).format("DD/MM/YYYY")}</td>
                <td><span className="cm_col">{project.projectManager.charAt(0).toUpperCase() + project.projectManager.slice(1)}</span></td>
                <td>{project?.accountManagerFirst + " " + project?.accountManagerLast}</td>
                <td style={{ textTransform: 'capitalize' }}><span className="cm_col">{project.clientName}</span></td>
                <td>{
                  project.status == 2 ? <span className="green">Completed</span> : (project.status == 3 ? <span className="red">Incomplete</span> : <span className={project.endDate >= new Date(date).setHours(0, 0, 0, 0) ? "ontrack" : "yellow"}>{handleDelayTime(project.endDate)}</span>)
                } </td>

                {
                  project.status == 1 ?
                    <td>
                      <div className="cm_ongoing">
                        <Select value={statusValue(project.status)} style={{ width: 130 }} onSelect={(e) => handleAction(project, e)}>
                          {/* <Option value="1" id="1">Ongoing</Option> */}
                          <Option value="2" id="2">Completed</Option>
                          <Option value="3" id="3">Incomplete</Option>
                          <Option value="5" id="5">On Hold</Option>

                        </Select></div>
                    </td>
                    : ''
                }

                {
                  project.status == 2 ?
                    <td>
                      <div className="cm_approve">
                        {/* <span>{statusValue(project.status)}</span> */}
                        <Select value={statusValue(project.status)} style={{ width: 130 }} onSelect={(e) => handleAction(project, e)}>
                          <Option value="4" id="4">Maintenance</Option>
                          <Option value="5" id="5">On Hold</Option>

                          {/* <Option value="2" id="2">Completed</Option> */}
                          {/* <Option value="3" id="3">Incomplete</Option> */}
                        </Select>
                      </div>
                    </td>
                    : ''
                }

                {
                  project.status == 3 ?
                    <td>
                      <div className="cm_reject">
                        <Select value={statusValue(project.status)} style={{ width: 130 }} onSelect={(e) => handleAction(project, e)} disabled>
                          <Option value="1" id="1">Ongoing</Option>
                          <Option value="2" id="2">Completed</Option>
                          <Option value="3" id="3">Incomplete</Option>
                          <Option value="5" id="5">On Hold</Option>

                        </Select>
                      </div>
                    </td>
                    : ''
                }
                {
                  project.status == 4 ?
                    <td>
                      <div className="cm_maintenance">
                        <Select value={statusValue(project.status)} style={{ width: 130 }} onSelect={(e) => handleAction(project, e)}>
                          {/* <Option value="1" id="1">Ongoing</Option> */}
                          <Option value="2" id="2">Completed</Option>
                          <Option value="3" id="3">Incomplete</Option>
                          <Option value="5" id="5">On Hold</Option>

                        </Select></div>
                    </td>
                    : ''
                }
                {
                  project.status == 5 ?
                    <td>
                      <div className="cm_onHold">
                        <Select value={statusValue(project.status)} style={{ width: 130 }} onSelect={(e) => handleAction(project, e)}>
                          <Option value="1" id="1">Ongoing</Option>
                          <Option value="2" id="2">Completed</Option>
                          <Option value="3" id="3">Incomplete</Option>
                          <Option value="4" id="4">Maintenance</Option>
                        </Select>
                      </div>
                    </td>
                    : ''
                }

              </tr>
            ))
            : ""}
        </tbody>
      </table>
      {projectList && projectList.length > 0 ? "" : <h3 className='text-center'>No data available</h3>}
    </div>

  </React.Fragment>
)



class ProjectsOfManager extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      projectList: [],
      search: '',
      status: '',
      projectId: '',
      projectStatus: '',
      totalProjects: '',
      totalOnGoingProjects: '',
      totalCompletedProjects: '',
      totalInCompleteProjects: '',
      totalMaintenanceProjects: "",
      onHoldProjects: "",
      pageNo: 1,
      dataCount: '',
      count: 10,
      loader: true,
      sortType: 2,
      sortField: 'created',
    }
    this.debounceSearch = null
  }
  handleSort = e => {
    this.setState({ loader: false, sortField: e, sortType: this.state.sortType === 1 ? 2 : 1 }, () => this.getProject());
  }
  handleSearch = e => {
    this.setState({ search: e.target.value, pageNo: 1 })
    clearTimeout(this.debouncedSearch);
    this.debounceSearch = setTimeout(() => {
      this.setState({ loader: true })
      this.getProject()
    }, 2000);

  }
  handleSelectChange = () => {
    this.setState({ search: '' }, () => this.getProject())
  }
  submitSearch = e => {
    e.preventDefault();
    this.setState({ loader: true })
    this.getProject()
  }

  handlePageChange = (pageNo) => {
    this.setState({ pageNo: pageNo, loader: true }, () => this.getProject());
  }

  handleTabChange = e => {

    this.setState({ loader: true, status: e == 0 ? "" : parseInt(e), pageNo: 1 }, () => this.getProject())
  }


  getProject = () => {
    let { search, status, sortType, sortField, pageNo, count } = this.state;

    let params = `search=${search.trim()}&status=${status}&sortType=${sortType}&sortField=${sortField}&count=${count}&pageNo=${pageNo - 1}`;
    this.props.history.push(`manager-projects?search=${search}&pageNo=${pageNo}&status=${status}&sortType=${sortType}&sortField=${sortField}`)


    projectListByManager(params).then(res => {

      let { status, resData } = ResponseFilter(res);
      if (status) {
        this.setState({
          projectList: resData.projectList,
          totalProjects: resData.totalProjects,
          totalOnGoingProjects: resData.totalOnGoingProjects,
          totalCompletedProjects: resData.totalCompletedProjects,
          totalInCompleteProjects: resData.totalInCompleteProjects,
          totalMaintenanceProjects: resData.totalMaintenanceProjects,
          onHoldProjects: resData.onHoldProjects,
          dataCount: resData.dataCount,

        }, () => this.setState({ loader: false }))
      }
      else {
        this.setState({ loader: false })
      }
    })
  }



  handleAction = (project, e) => {
    let params = {
      'projectId': project.projectId,
      'status': e

    }
    this.setState({ loader: true })
    projectActionByManager(params)
      .then(res => {
        this.setState({ miniLoader: false }, () => this.getProject())
      })
  }

  componentDidMount() {
    let url_string = window.location.href
    let url = new URL(url_string);
    let pageNo = url.searchParams.get("pageNo");
    let status = url.searchParams.get("status");
    let search = url.searchParams.get("search");
    let sortType = url.searchParams.get("sortType");
    let sortField = url.searchParams.get("sortField");
    this.setState({
      pageNo: pageNo ? +(pageNo) : 1,
      search: search ? search : "",
      sortType: sortType ? sortType : 1,
      sortField: sortField ? sortField : "",
      status: status ? status : "",
    }, () => {
      this.getProject();
    })
  }
  render() {
    let { projectList, dataCount, search, loader, totalProjects, pageNo, count, totalOnGoingProjects, totalCompletedProjects, totalInCompleteProjects, totalMaintenanceProjects, status, onHoldProjects } = this.state;
    return (
      <div className="body_container cm_bold">
        {
          loader && <Loader />
        }

        <div className="cm_breadcrumb cm_bold">
          <ul>
            <li><Link to='/projects'>PROJECT LIST</Link><div className="cm_breadcrumb_arrow"></div></li>
            <li>PROJECT  LIST  AS  MANAGER</li>
          </ul>
        </div>

        <h3 className="mb-4 undefined mt-5">PROJECT LIST</h3>

        <div className="row d-flex justify-content-end mb-4">

          <div className="col-md-6 search_device_bar select__date">

            <input className="form-control mr-lg-2 cm_box"

              type="search"
              placeholder="Search by Project Name"
              maxLength={40}
              aria-label="Search"
              value={search}
              onChange={this.handleSearch}
              // onKeyDown={(e) => { if (e.key === 'Enter') this.getProject() }}
            />
            {search ? <span className="cm_clear" onClick={this.handleSelectChange}><i className="fa fa-times-circle" aria-hidden="true"></i></span> : <span className="cm_clear"><i className="fa fa-search" aria-hidden="true" ></i></span>}

          </div>

        </div>
        <Tabs activeKey={status ? status : "0"} id="uncontrolled-tab-example" className="uncontrolled-tab-example" onSelect={(e) => this.handleTabChange(e)}>
          <Tab eventKey="0" title={`All ${totalProjects ? totalProjects : 0}`} >
            <ProjectTable {...this.state}
              handleSort={this.handleSort}
              handleAction={this.handleAction} />
            {dataCount > 10 ? <Pagination
              activePage={pageNo}
              pageNo={pageNo}
              itemsCountPerPage={count}
              totalItemsCount={totalProjects}
              pageRangeDisplayed={3}
              onChange={this.handlePageChange}
            /> : ''}
          </Tab>

          <Tab eventKey="1" title={`Ongoing ${totalOnGoingProjects ? totalOnGoingProjects : 0}`}>
            <ProjectTable {...this.state}
              handleSort={this.handleSort}
              handleAction={this.handleAction} />
            {dataCount > 10 ? <Pagination
              activePage={pageNo}
              pageNo={pageNo}
              itemsCountPerPage={count}
              totalItemsCount={dataCount}
              pageRangeDisplayed={3}
              onChange={this.handlePageChange}
            /> : ''}
          </Tab>

          <Tab eventKey="2" title={`Completed ${totalCompletedProjects ? totalCompletedProjects : 0}`}>
            <ProjectTable {...this.state}
              handleSort={this.handleSort}
              handleAction={this.handleAction} />
            {dataCount > 10 ? <Pagination
              activePage={pageNo}
              pageNo={pageNo}
              itemsCountPerPage={count}
              totalItemsCount={dataCount}
              pageRangeDisplayed={3}
              onChange={this.handlePageChange}
            /> : ""}
          </Tab>

          <Tab eventKey="3" title={`Incomplete ${totalInCompleteProjects ? totalInCompleteProjects : 0}`}>
            <ProjectTable {...this.state}
              handleSort={this.handleSort}
              handleAction={this.handleAction} />
            {dataCount > 10 ? <Pagination
              activePage={pageNo}
              pageNo={pageNo}
              itemsCountPerPage={count}
              totalItemsCount={dataCount}
              pageRangeDisplayed={3}
              onChange={this.handlePageChange}
            /> : ""}

          </Tab>
          <Tab eventKey="4" title={`Maintenance ${totalMaintenanceProjects ? totalMaintenanceProjects : 0}`}>
            <ProjectTable {...this.state}
              handleSort={this.handleSort}
              handleAction={this.handleAction} />
            {dataCount > 10 ? <Pagination
              activePage={pageNo}
              pageNo={pageNo}
              itemsCountPerPage={count}
              totalItemsCount={dataCount}
              pageRangeDisplayed={3}
              onChange={this.handlePageChange}
            /> : ""}

          </Tab>


          <Tab eventKey="5" title={`On Hold ${onHoldProjects ? onHoldProjects : 0}`}>
            <ProjectTable {...this.state}
              handleSort={this.handleSort}
              handleAction={this.handleAction} />
            {dataCount > 10 ? <Pagination
              activePage={pageNo}
              pageNo={pageNo}
              itemsCountPerPage={count}
              totalItemsCount={dataCount}
              pageRangeDisplayed={3}
              onChange={this.handlePageChange}
            /> : ""}

          </Tab>
        </Tabs>


      </div>
    );
  }
}
export default ProjectsOfManager;